import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconWarningArrow = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <svg
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="6119"
      width="32"
      height="32"
      className="yfm-icon yfm-icon-warning-arrow"
      {...omit(props, ["className"])}
      ref={ref}
    >
      <path
        d="M921.7 338.4C898.3 284.2 866.4 237 826 196.7c-40.3-40.3-87.5-72.2-141.5-95.6C630.5 77.7 572.7 66 511.1 66c-61.6 0-119.4 11.7-173.4 35.1-54 23.4-101.1 55.3-141.5 95.6-40.3 40.3-72.2 87.5-95.7 141.7C77.3 392.6 65.6 450.5 65.6 512s11.7 119.3 35.2 173.2c23.4 53.9 55.3 101 95.7 141.3 40.3 40.3 87.5 72.2 141.5 95.6 54 23.4 111.8 35.1 173.4 35.1 61.6 0 119.4-11.7 173.4-35.1 54-23.4 101.1-55.3 141.5-95.6 40.3-40.3 72.2-87.4 95.7-141.3 23.4-53.9 35.2-111.6 35.2-173.2-0.3-61.5-12-119.4-35.5-173.6zM511.2 799.5c-27.9 0-50.4-22.6-50.4-50.4 0-27.8 22.6-50.4 50.4-50.4 27.9 0 50.4 22.6 50.4 50.4 0.1 27.8-22.5 50.4-50.4 50.4z m50.5-209.6c0 27.8-22.6 50.4-50.4 50.4-27.9 0-50.4-22.6-50.4-50.4V274.1c0-27.8 22.6-50.4 50.4-50.4 27.9 0 50.4 22.6 50.4 50.4v315.8z m0 0"
        fill="#53e1df"
        p-id="6120"
      ></path>
    </svg>
  )
);

IconWarningArrow.displayName = "IconWarningArrow";

export default IconWarningArrow;
